//#region src/constants/conversation-types.ts
var e = "inbound", t = "Customer", n = "outbound", r = "Reply to Bot/Message", i = {
	[e]: ["UserMessage", "BotIntroMessage"],
	[n]: [
		"BotAutoMessage",
		"VisitorAutoMessage",
		"AutoMessage",
		"TriggeredMessage",
		"ManualMessage",
		"CampaignMessage",
		"DisplayableContent"
	]
}, a = [{
	value: "user",
	text: "User (Leads & Contacts)"
}, {
	value: "teammate",
	text: "Teammate"
}], o = a.map((e) => e.value);
//#endregion
export { i as CONVERSATION_TYPE_MAPPINGS, e as INBOUND, t as INBOUND_TEXT, n as OUTBOUND, r as OUTBOUND_TEXT, a as PARTICIPANT_TYPES, o as PARTICIPANT_TYPE_VALUES };
